import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Simple scroll-reveal: slow fade + subtle upward translation.
export default function Reveal({ children, delay = 0, y = 30, className = "", once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line text reveal.
export function RevealLines({ lines, className = "", lineClassName = "", start = false, delay = 0 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={start ? { y: "0%" } : { y: "110%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
